export function getMoEngageInstance() {
  if (typeof window === "undefined") return null;
  return window.Moengage || null;
}

function callIfExists(methodNames, ...args) {
  const moe = getMoEngageInstance();
  if (!moe) return false;

  for (const name of methodNames) {
    const fn = moe?.[name];
    if (typeof fn === "function") {
      fn.apply(moe, args);
      return true;
    }
  }

  return false;
}

export function moeAddFirstName(firstName) {
  if (!firstName) return false;
  return callIfExists(["add_first_name", "setFirstName"], firstName);
}

export function moeAddEmail(email) {
  if (!email) return false;
  return callIfExists(["add_email", "setEmail"], email);
}

export function moeAddUniqueUserId(userId) {
  if (!userId) return false;
  return callIfExists(["add_unique_user_id", "setUniqueId", "setUserId"], userId);
}

export function moeTrackEvent(eventName, eventDetails) {
  if (!eventName) return false;
  return callIfExists(["track_event", "trackEvent", "track"], eventName, eventDetails);
}
